import { Card } from 'antd';
import React, { useMemo } from 'react';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { AssetConElementResponse } from '../../../services/assets';

import { FinAssetConElementResponse } from '../../../services/finassets';

import GetLabel from 'DisplayFramework/components/GetLabel';
import { toCurrency } from 'utils/utils';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';

type AssetConElementProps = {
  data: any;
  currcode?: string;
  ctstatus?: string;
  phase?: string;
};

const AssetConElement = (props: AssetConElementProps) => {
  const { data, currcode, ctstatus, phase } = props;


  const columns = useMemo<
    DataGridColDef<FinAssetConElementResponse | AssetConElementResponse>[]
  >(
    () => [
      {
        comcode: 'conelement.ctreference',
        dataIndex: phase === 'PROPOSAL' ? 'propreference' : 'ctreference',
        width: 150,
        fixed: 'left',
        render: (ctreference, record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {phase === 'PROPOSAL' ? record?.propreference : record?.ctreference}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ProposalModal
                  ctrid={record.ctrid}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title=""
                  iscreate={false}
                  phase={phase === undefined ? 'PROD' : phase}
                />
              )}
            ></ModalControllerNV>
          );
        },
      },
      {
        comcode: 'conelement.cteorder',
        dataIndex: 'cteorder',
        width: 80,
      },
      {
        comcode: 'conelement.tpname',
        dataIndex: 'tpname',
        width: 250,
        render: (tpname, record) => {
          return (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {tpname}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <ThirdPartyModal
                  tpId={record.tpid}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={record.tpname}
                  iscreate={false}
                />
              )}
            />
          );
        },
      },
      {
        comcode: 'conelement.ctestatuslabel',
        dataIndex: 'ctestatuslabel',
        width: 150,
      },
      {
        comcode: 'conelement.finamountin',
        dataIndex: 'finamountin',
        width: 150,
        render: (val) =>
          toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      },
      {
        comcode: 'conelement.finamountout',
        dataIndex: 'finamountout',
        width: 150,
        render: (val) =>
          toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      },
      {
        comcode: 'conelement.startdate',
        dataIndex: 'startdate',
        width: 150,
      },
      {
        comcode: 'conelement.enddate',
        dataIndex: 'endate',
        width: 150,
      },
    ],
    [currcode, phase]
  );

  return (
    <Card title={<GetLabel label="associatedContracts" style={{fontWeight:'bold',paddingLeft:15}}/>}>
      <DataGrid
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.associd}
      />
    </Card>
  );
};

export default AssetConElement;
